import type { Shadows } from '@mui/material/styles';

/**
 * Dark theme shadows - glow effects with cyan/violet
 */
export const darkShadows: Shadows = [
  'none',
  '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  '0 0 20px rgba(0, 242, 234, 0.15)',
  '0 0 35px rgba(0, 242, 234, 0.25), 0 0 10px rgba(124, 58, 237, 0.2)',
  '0 0 40px -10px rgba(0, 242, 234, 0.5)',
  '0 10px 25px -5px rgba(0, 242, 234, 0.25)',
  '0 20px 40px -10px rgba(0, 242, 234, 0.4)',
  '0 4px 20px -2px rgba(0, 0, 0, 0.5)',
  '0 0 15px rgba(34, 211, 238, 0.3)',
  '0 0 30px rgba(167, 139, 250, 0.2)',
  '0 0 20px rgba(167, 139, 250, 0.2)',
  '0 0 10px rgba(34, 211, 238, 0.2)',
  '0 0 10px rgba(124, 58, 237, 0.2)',
  '0 0 15px rgba(0, 242, 234, 0.5)',
  '0 0 20px rgba(0, 242, 234, 0.15)',
  '0 0 35px rgba(0, 242, 234, 0.25)',
  '0 0 40px -10px rgba(0, 242, 234, 0.5)',
  '0 10px 25px -5px rgba(0, 242, 234, 0.25)',
  '0 20px 40px -10px rgba(0, 242, 234, 0.4)',
  '0 4px 20px -2px rgba(0, 0, 0, 0.5)',
  '0 0 15px rgba(34, 211, 238, 0.3)',
];

/**
 * Light theme shadows - subtle, border-based elevation
 */
export const lightShadows: Shadows = [
  'none',
  '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '0 0 15px rgba(0, 212, 204, 0.1)',
  '0 0 25px rgba(0, 212, 204, 0.15), 0 0 8px rgba(124, 58, 237, 0.1)',
  '0 0 30px -8px rgba(0, 212, 204, 0.3)',
  '0 8px 20px -4px rgba(0, 212, 204, 0.15)',
  '0 15px 30px -8px rgba(0, 212, 204, 0.25)',
  '0 4px 16px -2px rgba(0, 0, 0, 0.1)',
  '0 0 12px rgba(0, 212, 204, 0.2)',
  '0 0 20px rgba(167, 139, 250, 0.15)',
  '0 0 15px rgba(167, 139, 250, 0.15)',
  '0 0 8px rgba(0, 212, 204, 0.15)',
  '0 0 8px rgba(124, 58, 237, 0.15)',
  '0 0 12px rgba(0, 212, 204, 0.3)',
  '0 0 15px rgba(0, 212, 204, 0.1)',
  '0 0 25px rgba(0, 212, 204, 0.15)',
  '0 0 30px -8px rgba(0, 212, 204, 0.3)',
  '0 8px 20px -4px rgba(0, 212, 204, 0.15)',
  '0 15px 30px -8px rgba(0, 212, 204, 0.25)',
  '0 4px 16px -2px rgba(0, 0, 0, 0.1)',
  '0 0 12px rgba(0, 212, 204, 0.2)',
];
